import React, { useEffect } from 'react';
import Checkbox from 'monday-ui-react-core/dist/Checkbox';
import { AddColumnDialogue } from '../../AddColumnDialogue';
import { useContext, useMemo, useState } from 'react';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import Tooltip from 'monday-ui-react-core/dist/Tooltip';
import InfoIcon from '../../../assets/icons/info.svg';
import { FileContext } from '../../../context/FileContext';
import styled from 'styled-components';
import { dateFormatOptionsList } from '../../../config/common';
import APP_CONFIG from '../../../config';
import AssignEmailControllers from './AssignEmailControllers';

const StyledDropdown = styled(Dropdown)`
  width: 200px;
  z-index: 1000;
  display: inline-block;
`;

const StyledDropdownForSaveIn = styled(Dropdown)`
  width: 167px;
`;

const SaveInDropdownContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    height: 17px;
    width: 17px;
  }
`;

const StyledTooltip = styled(Tooltip)`
  width: 355px;
  text-align: center;
`;
const DatePickerController = ({
  t,
  selectedItem,
  addedFormFields,
  updateFormFields,
  queryData,
}) => {
  function handleIsRequiredChange(e) {
    const isChecked = e.target.checked;
    selectedItem.required = isChecked;
    updateFormFields([...addedFormFields]);
  }

  const { boardId, boardName } = useContext(FileContext);
  const [showAddColumnDialog, setShowAddColumnDialog] = useState({
    show: false,
    type: '',
  });

  function handleDateFormatChange(value) {
    selectedItem.format = value;
    updateFormFields([...addedFormFields]);
  }

  function handleSaveInCheckboxChange(e) {
    const isChecked = e.target.checked;
    selectedItem.saveIn = isChecked;
    updateFormFields([...addedFormFields]);
  }

  const saveInOptions = useMemo(() => {
    const preSeletedColumns = [];

    addedFormFields
      ?.filter(
        (field) =>
          field.itemId ===
            APP_CONFIG.form_fields.standard_fields.datePicker.id &&
          field.id !== selectedItem?.id,
      )
      ?.forEach((val) => {
        if (val?.column?.value) {
          preSeletedColumns.push(val.column.value);
        }
      });

    const options = queryData?.data?.items[0]?.column_values
      ?.filter(
        (column) =>
          column.type === 'date' && !preSeletedColumns.includes(column.id),
      )
      ?.map((x, index) => {
        return { value: x.id, label: x.title };
      });

    if (Array.isArray(options)) {
      options.push({
        value: 'add-new-column',
        label: `+ ${t('Add new date column')}`,
        onClick: (value) => {
          setShowAddColumnDialog({ show: true, type: 'date' });
        },
      });
    }
    return options;
  }, [queryData?.data?.items, addedFormFields, selectedItem]);

  function handleSaveInOptionsChange(value) {
    if (value?.onClick) {
      return value.onClick();
    }

    selectedItem.column = value;
    updateFormFields([...addedFormFields]);
  }

  const handleCloseDialogue = () => {
    setShowAddColumnDialog({ show: false, type: '' });
  };

  useEffect(() => {
    if (!selectedItem?.format) {
      selectedItem.format = dateFormatOptionsList[0];
      updateFormFields([...addedFormFields]);
    }
  }, [selectedItem]);

  return (
    <>
      {Boolean(showAddColumnDialog?.show) ? (
        <AddColumnDialogue
          handleClose={handleCloseDialogue}
          type={showAddColumnDialog.type}
          boardId={boardId}
        />
      ) : null}
      <Checkbox
        label={t('Required')}
        checked={selectedItem?.required}
        onChange={handleIsRequiredChange}
      />

      <StyledDropdown
        clearable={false}
        options={dateFormatOptionsList}
        size={Dropdown.size.SMALL}
        value={selectedItem.format}
        placeholder={`-- ${t('Select date format')} --`}
        className="dropdown-stories-styles_with-chips"
        onChange={handleDateFormatChange}
      />

      <Checkbox
        label={t('Save In')}
        checked={selectedItem?.saveIn}
        onChange={handleSaveInCheckboxChange}
      />

      <SaveInDropdownContainer>
        <StyledDropdownForSaveIn
          clearable={false}
          placeholder={t('Select Column')}
          value={selectedItem.column}
          options={saveInOptions}
          disabled={!selectedItem?.saveIn}
          size={Dropdown.size.SMALL}
          className="dropdown-stories-styles_with-chips"
          onChange={handleSaveInOptionsChange}
        />

        <StyledTooltip
          content={`${t(
            'Use this to select where you want this input data saved on',
          )} ${boardName} ${t('Board')}`}
          zIndex={4}
        >
          <img src={InfoIcon} alt="" />
        </StyledTooltip>
      </SaveInDropdownContainer>
      <AssignEmailControllers
        t={t}
        hideTipseen
        selectedItem={selectedItem}
        addedFormFields={addedFormFields}
        updateFormFields={updateFormFields}
      />
    </>
  );
};

export default DatePickerController;
